import React, { useState, useEffect } from 'react';
import historias from '../data/historias.json';
import { setSEO } from '../lib/seo';
import Testimonios from '../components/Testimonios';

const C = { navy:'#001f3a', navyMid:'#0b3558', navyDark:'#0d1f30', orange:'#f07820', orangeDk:'#9a4600', light:'#f8f9ff', white:'#ffffff' };
const LOGO_W = `${process.env.PUBLIC_URL}/LogoBlanco.png`;

const TIPOS = {
  'caso-real':   { label:'Caso real',     bg:'rgba(15,118,110,.1)',  color:'#0a5c52', border:'rgba(15,118,110,.25)', side:'linear-gradient(160deg,#001f3a,#0b3558)' },
  'estrategia':  { label:'Estrategia',    bg:'rgba(240,120,32,.08)', color:'#7a3e0e', border:'rgba(240,120,32,.3)',  side:'linear-gradient(160deg,#2d1a00,#7a3e0e)' },
  'guia':        { label:'Guía práctica', bg:'rgba(37,99,235,.08)',  color:'#1e3a8a', border:'rgba(37,99,235,.25)', side:'linear-gradient(160deg,#0c1a40,#1e3a8a)' },
  'metodologia': { label:'Metodología',   bg:'rgba(124,58,237,.08)', color:'#4c1d95', border:'rgba(124,58,237,.25)',side:'linear-gradient(160deg,#1a0a2e,#4c1d95)' },
};

const FILTROS = [
  { key:'todos',       label:'Todos'         },
  { key:'caso-real',   label:'Caso real'     },
  { key:'estrategia',  label:'Estrategia'    },
  { key:'guia',        label:'Guía práctica' },
  { key:'metodologia', label:'Metodología'   },
];

const PAGE_SIZE = 6;

export default function WebHistorias() {
  const [filtro,   setFiltro]   = useState('todos');
  const [visibles, setVisibles] = useState(PAGE_SIZE);

  useEffect(() => {
    setSEO({
      title: 'Historias Reales de Empleo Remoto en LATAM | HireMeUp',
      description: 'Casos reales de profesionales de LATAM que consiguieron trabajo remoto internacional con la metodologia HireMeUp. Estrategia comprobada, no suerte.',
      canonical: 'https://hiremeupglobal.com/historias',
    });
  }, []);

  const ordenadas = [...historias].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  const filtradas = filtro === 'todos' ? ordenadas : ordenadas.filter(h => h.tipo === filtro);
  const mostradas = filtradas.slice(0, visibles);
  const hayMas    = visibles < filtradas.length;
  const destacada = mostradas[0];
  const resto     = mostradas.slice(1);

  const S = `
    @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@700;800;900&family=Inter:wght@400;500;600;700&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    body{font-family:'Inter',sans-serif;background:${C.light};color:${C.navy}}
    .d{font-family:'Manrope',sans-serif} a{text-decoration:none}
    .bo{background:linear-gradient(135deg,${C.orange},${C.orangeDk});color:white;border:none;cursor:pointer;font-family:'Inter',sans-serif;font-weight:700;transition:opacity .18s,transform .18s;display:inline-flex;align-items:center;gap:8px}
    .bo:hover{opacity:.9;transform:translateY(-1px)}
    .ch{transition:box-shadow .2s,transform .2s} .ch:hover{box-shadow:0 12px 40px rgba(0,31,58,.1);transform:translateY(-2px)}
    @media(max-width:768px){
      .hero-flex{flex-direction:column!important}
      .hero-logo{display:none!important}
      .feat-inner{flex-direction:column!important}
      .feat-side{width:100%!important;height:100px!important;flex-direction:row!important;gap:16px!important;padding:16px 20px!important}
      .std-side{display:none!important}
      .filters-wrap{gap:6px!important}
    }
  `;

  return (
    <>
      <style>{S}</style>

      {/* ── NAVBAR ── */}
      <nav style={{ background:C.navy, height:'56px', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 40px', position:'sticky', top:0, zIndex:100 }}>
        <a href="/"><img src={LOGO_W} alt="HireMeUp" style={{ height:'32px', objectFit:'contain' }} /></a>
        <div style={{ display:'flex', gap:'10px' }}>
          <a href="https://app.hiremeupglobal.com/login" style={{ color:'rgba(255,255,255,.7)', fontSize:'13px', padding:'7px 14px', borderRadius:'8px', border:'1.5px solid rgba(255,255,255,.2)' }}>Ingresar</a>
          <a href="https://app.hiremeupglobal.com/register" className="bo" style={{ padding:'7px 16px', borderRadius:'8px', fontSize:'13px' }}>Empezar gratis</a>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section style={{ background:`linear-gradient(135deg,${C.navy} 0%,${C.navyMid} 100%)`, padding:'52px 40px 44px' }}>
        <div className="hero-flex" style={{ maxWidth:'900px', margin:'0 auto', display:'flex', alignItems:'center', gap:'60px' }}>

          {/* Texto izquierda */}
          <div style={{ flex:1, minWidth:'260px' }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:'6px', background:'rgba(240,120,32,.12)', border:'1px solid rgba(240,120,32,.25)', borderRadius:'20px', padding:'4px 14px', marginBottom:'20px' }}>
              <div style={{ width:'5px', height:'5px', borderRadius:'50%', background:C.orange }} />
              <span style={{ fontSize:'10px', fontWeight:700, color:C.orange, letterSpacing:'.12em', textTransform:'uppercase' }}>Historias reales · Sin filtro</span>
            </div>
            <h1 className="d" style={{ fontSize:'clamp(2rem,5vw,3rem)', fontWeight:900, color:'white', letterSpacing:'-.03em', lineHeight:1.05, marginBottom:'12px' }}>
              El trabajo remoto<br />no es suerte.<br /><span style={{ color:C.orange }}>Es estrategia.</span>
            </h1>
            <p style={{ fontSize:'15px', color:'rgba(255,255,255,.5)', lineHeight:1.7, maxWidth:'420px', marginBottom:'28px' }}>
              Casos reales de profesionales de LATAM que cambiaron su trayectoria con metodología, no con magia.
            </p>
            <div style={{ display:'flex', gap:'28px' }}>
              {[['600+','Profesionales activos'],['68%','Más entrevistas en 30 días'],['+10','Países LATAM']].map(([n,l]) => (
                <div key={n}>
                  <div className="d" style={{ fontSize:'24px', fontWeight:900, color:C.orange, letterSpacing:'-.03em', lineHeight:1 }}>{n}</div>
                  <div style={{ fontSize:'10px', color:'rgba(255,255,255,.35)', marginTop:'3px' }}>{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Logo derecha */}
          <div className="hero-logo" style={{ flex:'0 0 240px', display:'flex', justifyContent:'center', alignItems:'center' }}>
            <img src={LOGO_W} alt="HireMeUp" style={{ width:'220px', objectFit:'contain', opacity:.92 }} />
          </div>

        </div>
      </section>

      {/* ── FILTROS ── */}
      <div className="filters-wrap" style={{ padding:'24px 40px 0', display:'flex', gap:'8px', flexWrap:'wrap', maxWidth:'900px', margin:'0 auto' }}>
        {FILTROS.map(f => {
          const tipo   = TIPOS[f.key];
          const activo = filtro === f.key;
          return (
            <button key={f.key} onClick={() => { setFiltro(f.key); setVisibles(PAGE_SIZE); }}
              style={{ fontSize:'11px', fontWeight:700, padding:'6px 16px', borderRadius:'20px', border:`1.5px solid ${activo ? (tipo?.border || C.navy) : 'rgba(0,31,58,.15)'}`, background: activo ? (tipo ? tipo.bg : C.navy) : 'white', color: activo ? (tipo ? tipo.color : 'white') : 'rgba(0,31,58,.5)', cursor:'pointer', letterSpacing:'.04em', textTransform:'uppercase', transition:'all .15s' }}>
              {f.label}
            </button>
          );
        })}
      </div>

      {/* ── LISTADO ── */}
      <div style={{ padding:'24px 40px 8px', maxWidth:'900px', margin:'0 auto', display:'flex', flexDirection:'column', gap:'14px' }}>

        {/* CARD DESTACADA */}
        {destacada && (() => {
          const tipo = TIPOS[destacada.tipo];
          return (
            <a href={`/historias/${destacada.id}`} className="ch" style={{ display:'block', background:'white', borderRadius:'16px', overflow:'hidden', border:`2px solid rgba(240,120,32,.2)`, textDecoration:'none', position:'relative' }}>
              <div style={{ position:'absolute', top:'14px', right:'14px', display:'inline-flex', alignItems:'center', gap:'5px', background:'rgba(240,120,32,.1)', border:'1px solid rgba(240,120,32,.25)', borderRadius:'20px', padding:'3px 10px' }}>
                <div style={{ width:'5px', height:'5px', borderRadius:'50%', background:C.orange }} />
                <span style={{ fontSize:'9px', fontWeight:700, color:C.orange, letterSpacing:'.08em', textTransform:'uppercase' }}>Nuevo</span>
              </div>
              <div className="feat-inner" style={{ display:'flex' }}>
                <div className="feat-side" style={{ width:'160px', flexShrink:0, background:tipo.side, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'28px 16px', gap:'12px' }}>
                  <div style={{ width:'60px', height:'60px', borderRadius:'50%', border:'2px solid rgba(240,120,32,.4)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Manrope,sans-serif', fontSize:'22px', fontWeight:900, color:'white', background:'rgba(240,120,32,.15)' }}>{destacada.avatar}</div>
                  <div style={{ textAlign:'center' }}>
                    <div style={{ fontSize:'11px', fontWeight:700, color:'white', marginBottom:'2px' }}>{destacada.autor}</div>
                    <div style={{ fontSize:'10px', color:'rgba(255,255,255,.4)' }}>{destacada.detalle}</div>
                  </div>
                  <div style={{ background:'rgba(240,120,32,.15)', border:'1px solid rgba(240,120,32,.3)', borderRadius:'10px', padding:'8px 10px', textAlign:'center', width:'100%' }}>
                    <div className="d" style={{ fontSize:'18px', fontWeight:900, color:C.orange, lineHeight:1 }}>{destacada.resultado.num}</div>
                    <div style={{ fontSize:'9px', color:'rgba(255,255,255,.5)', marginTop:'2px', textTransform:'uppercase', letterSpacing:'.06em' }}>{destacada.resultado.lbl}</div>
                  </div>
                </div>
                <div style={{ padding:'28px', flex:1 }}>
                  <span style={{ display:'inline-block', fontSize:'9px', fontWeight:700, padding:'3px 10px', borderRadius:'20px', letterSpacing:'.08em', textTransform:'uppercase', background:tipo.bg, color:tipo.color, border:`1px solid ${tipo.border}`, marginBottom:'10px' }}>{tipo.label}</span>
                  <div className="d" style={{ fontSize:'18px', fontWeight:800, color:C.navy, letterSpacing:'-.02em', lineHeight:1.25, marginBottom:'8px' }}>{destacada.titulo}</div>
                  <div style={{ fontSize:'13px', color:'rgba(0,31,58,.55)', lineHeight:1.65, marginBottom:'16px' }}>{destacada.extracto}</div>
                  <div style={{ display:'flex', alignItems:'center', gap:'16px' }}>
                    <span style={{ fontSize:'11px', color:'rgba(0,31,58,.35)' }}>{new Date(destacada.fecha).toLocaleDateString('es-ES', { month:'long', year:'numeric' })} · {destacada.lectura}</span>
                    <span style={{ fontSize:'11px', fontWeight:700, color:C.orange }}>Leer historia completa →</span>
                  </div>
                </div>
              </div>
            </a>
          );
        })()}

        {/* CARDS RESTO */}
        {resto.map(h => {
          const tipo = TIPOS[h.tipo];
          return (
            <a key={h.id} href={`/historias/${h.id}`} className="ch" style={{ display:'flex', background:'white', borderRadius:'14px', overflow:'hidden', border:'0.5px solid rgba(0,31,58,.07)', textDecoration:'none' }}>
              <div className="std-side" style={{ width:'100px', flexShrink:0, background:tipo.side, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'16px 10px', gap:'8px' }}>
                <div style={{ width:'40px', height:'40px', borderRadius:'50%', border:'1.5px solid rgba(240,120,32,.35)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Manrope,sans-serif', fontSize:'15px', fontWeight:900, color:'white', background:'rgba(255,255,255,.08)' }}>{h.avatar}</div>
                <div style={{ textAlign:'center' }}>
                  <div style={{ fontSize:'10px', fontWeight:700, color:'white', marginBottom:'2px' }}>{h.autor}</div>
                  <div style={{ fontSize:'9px', color:'rgba(255,255,255,.4)' }}>{h.detalle}</div>
                </div>
                <div style={{ background:'rgba(240,120,32,.15)', border:'1px solid rgba(240,120,32,.25)', borderRadius:'8px', padding:'5px 6px', textAlign:'center', width:'100%' }}>
                  <div className="d" style={{ fontSize:'13px', fontWeight:900, color:C.orange, lineHeight:1 }}>{h.resultado.num}</div>
                  <div style={{ fontSize:'8px', color:'rgba(255,255,255,.4)', marginTop:'1px', textTransform:'uppercase', letterSpacing:'.05em' }}>{h.resultado.lbl}</div>
                </div>
              </div>
              <div style={{ padding:'18px', flex:1 }}>
                <span style={{ display:'inline-block', fontSize:'9px', fontWeight:700, padding:'3px 10px', borderRadius:'20px', letterSpacing:'.08em', textTransform:'uppercase', background:tipo.bg, color:tipo.color, border:`1px solid ${tipo.border}`, marginBottom:'8px' }}>{tipo.label}</span>
                <div className="d" style={{ fontSize:'14px', fontWeight:800, color:C.navy, letterSpacing:'-.02em', lineHeight:1.25, marginBottom:'6px' }}>{h.titulo}</div>
                <div style={{ fontSize:'12px', color:'rgba(0,31,58,.55)', lineHeight:1.6, marginBottom:'10px', overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{h.extracto}</div>
                <div style={{ display:'flex', alignItems:'center', gap:'16px' }}>
                  <span style={{ fontSize:'11px', color:'rgba(0,31,58,.35)' }}>{new Date(h.fecha).toLocaleDateString('es-ES', { month:'long', year:'numeric' })} · {h.lectura}</span>
                  <span style={{ fontSize:'11px', fontWeight:700, color:C.orange }}>Leer →</span>
                </div>
              </div>
            </a>
          );
        })}
      </div>

      {/* ── VER MÁS ── */}
      {hayMas && (
        <div style={{ padding:'16px 40px 32px', maxWidth:'900px', margin:'0 auto', textAlign:'center' }}>
          <button onClick={() => setVisibles(v => v + PAGE_SIZE)}
            style={{ fontSize:'12px', fontWeight:700, color:'rgba(0,31,58,.5)', background:'white', border:'1.5px solid rgba(0,31,58,.12)', padding:'11px 32px', borderRadius:'10px', cursor:'pointer', letterSpacing:'.04em' }}>
            Ver más historias ({filtradas.length - visibles} restantes) ↓
          </button>
        </div>
      )}

      {/* ── TESTIMONIOS ── */}
      <Testimonios />

      {/* ── CTA ── */}
      <div style={{ background:`linear-gradient(135deg,${C.navy},${C.navyMid})`, padding:'32px 40px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'20px', flexWrap:'wrap', marginTop:'24px' }}>
        <div>
          <div className="d" style={{ fontSize:'18px', fontWeight:900, color:'white', letterSpacing:'-.02em', marginBottom:'4px' }}>¿Tu historia puede ser la próxima?</div>
          <div style={{ fontSize:'13px', color:'rgba(255,255,255,.45)' }}>Empieza hoy con la metodología que ya funciona en +10 países de LATAM.</div>
        </div>
        <a href="https://app.hiremeupglobal.com/register" className="bo" style={{ padding:'12px 24px', borderRadius:'10px', fontSize:'14px', flexShrink:0 }}>Empieza gratis →</a>
      </div>

      {/* ── FOOTER ── */}
      <footer style={{ background:C.navyDark, padding:'20px 40px', borderTop:'1px solid rgba(255,255,255,.06)', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'12px' }}>
        <img src={LOGO_W} alt="HireMeUp" style={{ height:'28px', objectFit:'contain' }} />
        <p style={{ fontSize:'12px', color:'rgba(255,255,255,.2)' }}>© 2026 HireMeUp Global</p>
      </footer>
    </>
  );
}
